<button
  type="button"
  [ngClass]="['flow-pill', active ? 'active' : '', disabled ? 'disabled' : '']"
  [style.width]="pillWidth"
  [disabled]="disabled"
  (click)="onClick()"
>
  @if (icon) {
    <span class="icon-wrapper" aria-hidden="true">
      <img [src]="icon" class="icon" />
    </span>
  }
  <span class="pill-label" agText="body-3-medium" style="font-size: 14px">{{ label }}</span>
</button>
